import { render, staticRenderFns } from "./DatosEntradasComponent.vue?vue&type=template&id=0ce2d3d2"
import script from "./DatosEntradasComponent.vue?vue&type=script&lang=js"
export * from "./DatosEntradasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports